import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/sections/ClientShowcase.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de371382fe6e8e/components/sections/CtaSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/sections/DeviceShowcase.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/sections/EnhancedTestimonials.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/sections/IntegrationsSection.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/tmp/8de371382fe6e8e/components/ui/LazyVideo.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/app/[locale]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/client/link.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
